<template>
  <div id="app">
    <Head v-if="layout"/>
    <transition name="header-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut">
      <router-view/>
    </transition>
    <Foot v-if="layout && layoutFoot"/>
  </div>
</template>
<script>
import Head from '@/components/header.vue'
import Foot from '@/components/footer.vue'

export default {
  name: 'App',
  components: {
    Head,
    Foot
  },
  data() {
    return {
      layout : false,
    }
  },
  methods : {
    toggleHeader(){
      var routeName = this.$route.name
      if(routeName == 'Coming Soon'){
        this.layout =false
        this.layoutFoot == false
      } else if(routeName == 'Error'){
        this.layout = true
        this.layoutFoot = false
      } else {
        this.layoutFoot = true
        this.layout = true
      }
    }
  },
  watch: {
      $route() {
        this.toggleHeader()
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
  },
}
</script>
